/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import axios from "axios";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import config from "../../../../config.json";
import "../../../i18n";
import { useTranslation } from "react-i18next";
import imgVide from "../../../assets/images/vide.png";
import { formatDualMoney } from "../../../utils/currency";

const ProductsHistory = ({
  product,
  fetchProducts,
  selected = false,
  onToggleSelect,
}) => {
  const { t } = useTranslation();
  const {
    _id,
    price,
    photos = [],
    productDetails = [],
    isArchived,
  } = product;

  const restoreProduct = async () => {
    try {
      await axios.put(`${config.dev}/v2/products/restore/${_id}`);
      swal(t("successTitle"), t("productIsActivated"), t("success"));
      fetchProducts();
    } catch (error) {
      swal(t("errorTitle"), "" + error, t("error"));
    }
  };

  const deleteProductForever = async () => {
    const ok = await swal({
      title: t("areYouSure") || "Are you sure?",
      text: t("deleteForeverWarning") || "This action cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });
    if (!ok) return;
    try {
      await axios.delete(`${config.dev}/v2/products/delete/${_id}`);
      swal(t("successTitle"), t("deletedSuccessfully") || "Deleted permanently", "success");
      fetchProducts();
    } catch (error) {
      swal(t("errorTitle"), error?.response?.data?.message || "" + error, t("error"));
    }
  };

  if (!isArchived) return null;

  const productTitle = productDetails.find((d) => d.language === "en")?.productTitle ||
    productDetails[0]?.productTitle ||
    "";

  return (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
      <div className="card h-100">
        <div className="card-body">
          <div className="d-flex justify-content-start mb-2">
            <input
              type="checkbox"
              className="form-check-input"
              checked={selected}
              onChange={(e) => onToggleSelect?.(_id, e.target.checked)}
            />
          </div>
          <div className="new-arrival-product">
            <div className="new-arrivals-img-contnent">
              <img
                className="img-fluid"
                src={
                  photos.length > 0
                    ? `${config.UPLOADS_SERVER}/product/${photos[0]}`
                    : imgVide
                }
                alt={productTitle}
                style={{
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>

            <div className="new-arrival-content text-center mt-3">
              <h4 className="text-black mb-2">{productTitle}</h4>
              <div className="d-flex justify-content-center align-items-start mb-3">
                <span
                  style={{ width: 120, alignSelf: "center" }}
                  className="badge bg-primary text-white"
                >
                  Price : {formatDualMoney(price || 0, product.secondaryPrice)}
                </span>
              </div>

              <div className="d-flex justify-content-center gap-2 pt-2 border-top">
                <Link
                  to={`/product-sheet/${_id}`}
                  className="btn btn-sm btn-outline-primary"
                >
                  <i className="fa fa-eye me-1" />
                  {t("details")}
                </Link>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={restoreProduct}
                >
                  <i className="fa fa-undo me-1" />
                  {t("restore")}
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={deleteProductForever}
                >
                  <i className="fa fa-trash me-1" />
                  {t("deleteForever") || "Delete forever"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsHistory;
